/** HSplitContainer registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseHSplitContainer } from './parser';
const hSplitContainerRegistration = {
    typeName: 'HSplitContainer',
    parser: parseHSplitContainer,
};
nodeRegistry.register(hSplitContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map